import * as Sentry from '@sentry/react';

import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

export const initSentry = () => {
  Sentry.init({
    enabled: envs[EnvironmentVariable.Environment] === 'prod',
    dsn: envs[EnvironmentVariable.SentryDsn],
    environment: envs[EnvironmentVariable.Environment],

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          '/api/verification-process/account',
          '/api/application-process/current-application',
        ],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you’re not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    allowUrls: [/https?:\/\/(www\.)?loan\.heightsfinance\.com/i],
    ignoreErrors: [
      /Token is invalid/i,

      /Could not load "(map|util)"/i,
      /runtime\.sendMessage/i,
      /Access is denied for this document/i,
      /iosPrompt/i,
      /FileReader/i,

      /Load failed/i,
      /Failed to fetch/i,
      /NetworkError/i,
      /Unexpected end of JSON input/i,
      /The string did not match the expected pattern/i,

      /this\.[a-zA-Z0-9]{2}\.close is not a function/i,
      /is not iterable/i,
      /Maximum call stack size exceeded/i,
      /paramsToTrack/i,
      /WKWebView API client did not respond to this postMessage/i,
    ],
  });
};
